export { default } from './BaseComponent.jsx'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/BaseComponent/index.js